<loading class="pos-fix vh-center"
         *ngIf="loading">
</loading>
<app-checkup-view-experiment [isFromListView]="isFromListView" [instantCheckup]="instantCheckup"></app-checkup-view-experiment>